var _path, _path2, _g, _circle, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBilling({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_17862",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 17862",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 31,
    viewBox: "0 0 46 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_5368",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 5368",
    d: "M4,1A3,3,0,0,0,1,4V24a3,3,0,0,0,3,3H38a3,3,0,0,0,3-3V4a3,3,0,0,0-3-3H4M4,0H38a4,4,0,0,1,4,4V24a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
    fill: "#1d1d1f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_5369",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 5369",
    d: "M2,1A1,1,0,0,0,1,2V8A1,1,0,0,0,2,9H9a1,1,0,0,0,1-1V2A1,1,0,0,0,9,1H2M2,0H9a2,2,0,0,1,2,2V8a2,2,0,0,1-2,2H2A2,2,0,0,1,0,8V2A2,2,0,0,1,2,0Z",
    transform: "translate(5 4)",
    fill: "#1d1d1f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_17862-2",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 17862",
    transform: "translate(5.5 17.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_622",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 622",
    d: "M6,.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H6a.5.5,0,0,1,.5.5A.5.5,0,0,1,6,.5Z",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_623",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 623",
    d: "M6,.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H6a.5.5,0,0,1,.5.5A.5.5,0,0,1,6,.5Z",
    transform: "translate(8)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_624",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 624",
    d: "M6,.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H6a.5.5,0,0,1,.5.5A.5.5,0,0,1,6,.5Z",
    transform: "translate(16)",
    fill: "#1d1d1f"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_6129",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 6129",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(32 17)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_6129_-_\\u0420\\u0430\\u043C\\u043A\\u0430",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 6129 - \\u0420\\u0430\\u043C\\u043A\\u0430",
    d: "M7,1a6,6,0,1,0,6,6A6.007,6.007,0,0,0,7,1M7,0A7,7,0,1,1,0,7,7,7,0,0,1,7,0Z",
    transform: "translate(32 17)",
    fill: "#1d1d1f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_625",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 625",
    d: "M21,.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H21a.5.5,0,0,1,.5.5A.5.5,0,0,1,21,.5Z",
    transform: "translate(5.5 21.5)",
    fill: "#1d1d1f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247627",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247627",
    d: "M407.318,490.161l-4.819,4.823-1.682-1.682a.391.391,0,1,0-.553.553l1.96,1.96a.385.385,0,0,0,.278.114.4.4,0,0,0,.278-.114l5.1-5.1a.391.391,0,0,0,0-.553A.4.4,0,0,0,407.318,490.161Z",
    transform: "translate(-364.835 -468.928)",
    fill: "#1d1d1f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.41d5a1d8b8f7346508f973dd9da18250.svg";
export { ForwardRef as ReactComponent };